import { UntilDestroy } from '@ngneat/until-destroy'
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { ModalContainerComponent } from '@components-library/tb-modal-manager/modal-container-component/modal-container.component'
import { TbButtonComponent } from '@components-library/tb-button/tb-button.component'
import { TemplateSelectorComponent } from '@app/feature/header/workspace-controls/advanced-options/status-section/template-selector/template-selector.component'
import { TranslocoModule } from '@jsverse/transloco'
import { TbTabsComponent } from '@components-library/tb-tabs/tb-tabs.component'
import { EnvDirective } from '@shared/env.directive'
import { TbTab } from '@components-library/tb-tab/tb-tab.component'
import { Field } from '@models/ui'
import { SelectObjectOptions } from '@core/models'
import { StatusSelectCellSettingsComponent } from '@app/feature/add-field/add-field-content/select-settings/status-select-cell-settings/status-select-cell-settings.component'
import { cloneDeep, keyBy } from 'lodash-es'
import { ModalLayoutComponent } from '@components-library/tb-modal-manager/modal-layout/modal-layout.component'
import { ModalLayoutButtonsComponent } from '@components-library/tb-modal-manager/modal-layout-buttons/modal-layout-buttons.component'

export interface StatusData {
    schemaTabs: TbTab[]
    statusBySchema: Record<string, Field>
}

@UntilDestroy()
@Component({
    selector: 'app-status-configuration',
    templateUrl: './status-configuration.component.html',
    imports: [
        TranslocoModule,
        TemplateSelectorComponent,
        TbButtonComponent,
        TbTabsComponent,
        EnvDirective,
        StatusSelectCellSettingsComponent,
        ModalLayoutComponent,
        ModalLayoutButtonsComponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusConfigurationComponent
    extends ModalContainerComponent<StatusData>
    implements OnInit
{
    selectedSOT!: TbTab
    currentStatus!: Field
    templateStatusFields: Record<string, Field> = {}
    selectObjectOptions: SelectObjectOptions = {}
    fieldsChanged = false

    ngOnInit(): void {
        this.templateStatusFields = this.data.statusBySchema
        this.changeTab()
    }

    hasChanged(): boolean {
        return this.fieldsChanged
    }

    protected fieldChanged(field: Field) {
        if (!this.fieldsChanged) this.fieldsChanged = true

        this.templateStatusFields[this.selectedSOT.id] = field
    }

    protected applyChanges() {
        this.close(this.templateStatusFields)
    }

    protected changeTab(tab?: TbTab) {
        this.selectedSOT = tab || this.data.schemaTabs[0]
        this.currentStatus = cloneDeep(this.templateStatusFields[this.selectedSOT.id])
        if (this.currentStatus.select_object_field_sorted) {
            this.selectObjectOptions = keyBy(
                cloneDeep(this.currentStatus.select_object_field_sorted!),
                'guid',
            )
        } else {
            this.selectObjectOptions = cloneDeep(this.currentStatus.select_object_field!)
        }
    }
}
